import React from 'react';
import {Drawer, Grid, IconButton, Table, TableBody, TableCell, TableHead, TableRow, withStyles} from "material-ui";
import {connect} from "react-redux";
import {CategoryForm} from "../../../forms/category";
import {
    closeCreateRegulationCategoryFetch,
    closeDeleteRegulationCategoryFetch,
    closeUpdateRegulationCategoryFetch,
    createRegulationCategory,
    deleteRegulationCategory,
    getRegulationCategories,
    updateRegulationCategory
} from "../../../redux/actions/regulation_categories";
import {Delete} from "material-ui-icons";
import {DeleteErrorDialog} from "../dialog/delete_error";

export class CategoryDrawer extends React.Component {

    state = {
        isCreated: false,
        errorDialogOpen: false,
    };

    handleSubmit = (values) => {
        if (values.id === undefined) {
            this.props.createRegulationCategory(values, () => {
                this.setState({isCreated: false});
                this.props.getRegulationCategories();
            });
        } else {
            this.props.updateRegulationCategory(values, () => {
                this.setState({isCreated: false});
                this.props.getRegulationCategories();
            });
        }
    };

    onClickNewCell = () => {
        if (!this.state.isCreated) {
            this.setState({isCreated: true});
        }
    };

    handleClose = () => {
        if (this.props.handleClose !== undefined) {
            this.props.handleClose();
        }
        this.setState({isCreated: false});
    };

    deleteCategory = (category) => {
        this.props.deleteRegulationCategory(category,
            () => {
                this.props.getRegulationCategories();
            },
            () => {
                this.setState({errorDialogOpen: true});
            });
    };

    errorDialogClose = () => {
        this.setState({errorDialogOpen: false});
    };

    render() {

        const {
            classes, open, errors,
            regulation_category,
            regulation_categories
        } = this.props;

        const {isCreated, errorDialogOpen} = this.state;


        return (
            <Drawer
                anchor="right"
                open={open}
                onClose={this.handleClose}>
                <div className={classes.root}>
                    <Table className={classes.table}>
                        <TableHead>
                            <TableRow>
                                <TableCell>カテゴリー</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {regulation_categories.map((n) => {
                                return (
                                    <TableRow key={n.id}>
                                        <TableCell>
                                            <Grid container alignItems="center">
                                                <Grid item xs={8}>{n.name}</Grid>
                                                <Grid item xs={4}>
                                                    <Grid container>
                                                        <Grid item xs={6}>
                                                            {/*<IconButton>*/}
                                                            {/*<Edit/>*/}
                                                            {/*</IconButton>*/}
                                                        </Grid>
                                                        <Grid item xs={6}>
                                                            <IconButton onClick={this.deleteCategory.bind(this, n)}>
                                                                <Delete/>
                                                            </IconButton>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </TableCell>
                                    </TableRow>
                                )
                            })}

                            <TableRow hover className={classes.clickRow}>
                                <TableCell onClick={this.onClickNewCell.bind(this)}>
                                    {isCreated ?
                                        <CategoryForm
                                            initialValues={regulation_category}
                                            ref="categoryForm"
                                            errors={errors}
                                            onSubmit={this.handleSubmit}/>
                                        : <span>+ 新規追加</span>}
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </div>
                <DeleteErrorDialog
                    open={errorDialogOpen}
                    handleClose={this.errorDialogClose}/>
            </Drawer>
        )
    }
}

const styles = theme => ({
    root: {
        width: 300,
    },
    clickRow: {
        cursor: 'pointer',
    },
});

CategoryDrawer = withStyles(styles)(CategoryDrawer);

CategoryDrawer = connect(
    (state) => {
        return {
            regulation_category: state.regulation_categories.regulation_category,
            regulation_categories: state.regulation_categories.regulation_categories,
            errors: state.regulation_categories.errors,
        }
    },
    (dispatch) => {
        return {
            getRegulationCategories: () => {
                dispatch(getRegulationCategories());
            },
            createRegulationCategory: (regulation_category, callback) => {
                dispatch(createRegulationCategory(regulation_category)).then((response) => {
                    setTimeout(() => {
                        dispatch(closeCreateRegulationCategoryFetch());
                        switch (response.type) {
                            case 'API_CREATE_REGULATION_CATEGORY_FAIL':
                                break;
                            default:
                                callback();
                        }
                    }, 300)
                });
            },
            updateRegulationCategory: (regulation_category, callback) => {
                dispatch(updateRegulationCategory(regulation_category)).then((response) => {
                    setTimeout(() => {
                        dispatch(closeUpdateRegulationCategoryFetch());
                        switch (response.type) {
                            case 'API_UPDATE_REGULATION_CATEGORY_FAIL':
                                break;
                            default:
                                callback();
                        }
                    }, 300);
                });
            },
            deleteRegulationCategory: (regulation_category, callback, error) => {
                dispatch(deleteRegulationCategory(regulation_category)).then((response) => {
                    setTimeout(() => {
                        dispatch(closeDeleteRegulationCategoryFetch());
                        switch (response.type) {
                            case 'API_DELETE_REGULATION_CATEGORY_FAIL':
                                error();
                                break;
                            default:
                                callback();
                        }
                    }, 300);
                });
            },
        }
    }
)(CategoryDrawer);


// WEBPACK FOOTER //
// ./src/containers/regulation/drawer/category.js